import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Bell_md = (props) => {
    const width = props.width ? props.width + 'px' : '24px';
    const height = props.height ? props.height + 'px' : '24px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox={props.BgColor ? "0 0 105 104" : "0 0 24 24"}
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            {props.BgColor ? <rect x="0.5" width="104" height="104" rx="50" fill={props.BgColor} /> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.87084 7.91736C5.87084 4.60997 8.65512 2 12 2C15.3449 2 18.1292 4.60997 18.1292 7.91736V12.3598C18.1292 12.7262 18.263 13.0872 18.5169 13.3789L20.4349 15.5826C21.7957 17.1459 20.5614 19.3846 18.6334 19.3846H5.36663C3.4386 19.3846 2.20427 17.1459 3.56505 15.5826L5.48308 13.3789C5.73704 13.0872 5.87084 12.7262 5.87084 12.3598V7.91736ZM12 4C9.67936 4 7.87084 5.79319 7.87084 7.91736V12.3598C7.87084 13.2183 7.55627 14.0433 6.99167 14.692L5.07363 16.8956L4.31934 16.2391L5.07363 16.8956C5.02118 16.9559 5.00568 17.0064 5.0014 17.0447C4.99658 17.0878 5.00391 17.1394 5.02985 17.1925C5.0797 17.2947 5.18753 17.3846 5.36663 17.3846H18.6334C18.8125 17.3846 18.9203 17.2947 18.9702 17.1925C18.9961 17.1394 19.0034 17.0878 18.9986 17.0447C18.9943 17.0064 18.9788 16.9559 18.9264 16.8956L17.0083 14.692C16.4437 14.0433 16.1292 13.2183 16.1292 12.3598V7.91736C16.1292 5.79319 14.3206 4 12 4ZM9.63598 22C9.63598 21.4477 10.0837 21 10.636 21H13.364C13.9163 21 14.364 21.4477 14.364 22C14.364 22.5523 13.9163 23 13.364 23H10.636C10.0837 23 9.63598 22.5523 9.63598 22Z"
                fill={props.color ? props.color: "white"} />
        </SvgStyled>
    );
};

export default Bell_md;
